import { formatDate, KeyValue } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { Errors as CLErrors } from '@corelabs/angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'error',
})
export class ErrorPipe implements PipeTransform {
    private readonly translateService = inject(TranslateService);

    transform(error: KeyValue<string, unknown>): string {
        switch (error.key) {
            case CLErrors.INVALID_DATE:
                return this.translateService.instant('forms.error.invalid-date');
            case CLErrors.REQUIRED:
                return this.translateService.instant('forms.error.required');
            case CLErrors.EMAIL:
                return this.translateService.instant('forms.error.email');
            case CLErrors.PHONE_NUMBER:
                return this.translateService.instant('forms.error.phone-number');
            case CLErrors.DATE_RANGE:
                return this.translateService.instant('forms.error.date-range');
            case CLErrors.POSTAL_CODE:
                return this.translateService.instant('forms.error.postal-code');
            case CLErrors.MIN_LENGTH: {
                const value = <{ requiredLength: number }>error.value;
                return this.translateService.instant('forms.error.min-length', { min: value.requiredLength });
            }
            case CLErrors.MAX_LENGTH: {
                const value = <{ requiredLength: number }>error.value;
                return this.translateService.instant('forms.error.max-length', { max: value.requiredLength });
            }
            case 'min': {
                const value = <{ min: number }>error.value;
                return this.translateService.instant('forms.error.min-value', { min: value.min });
            }
            case 'max': {
                const value = <{ max: number }>error.value;
                return this.translateService.instant('forms.error.max-value', { max: value.max });
            }
            case 'minDate': {
                const value = <{ min: Date }>error.value;
                return this.translateService.instant('forms.error.min-date', { min: formatDate(value.min, 'dd.MM.yyyy', 'en-US') });
            }
            case 'maxDate': {
                const value = <{ max: Date }>error.value;
                return this.translateService.instant('forms.error.max-date', { max: formatDate(value.max, 'dd.MM.yyyy', 'en-US') });
            }
            case CLErrors.NIP:
                return this.translateService.instant('forms.error.nip');
            case CLErrors.WORDS:
                return this.translateService.instant('forms.error.words');
            case CLErrors.WORDS_AND_NUMBERS:
                return this.translateService.instant('forms.error.words-and-numbers');
            case CLErrors.TEXT:
                return this.translateService.instant('forms.error.text');
            case CLErrors.NUMBERS:
                return this.translateService.instant('forms.error.numbers');
            case CLErrors.MUST_MATCH:
                return this.translateService.instant('forms.error.must-match');
            case CLErrors.INVALID_URL:
                return this.translateService.instant('forms.error.invalid-url');
            case CLErrors.AT_LEAST_LOWER:
                return this.translateService.instant('forms.error.at-least-lower');
            case CLErrors.AT_LEAST_UPPER:
                return this.translateService.instant('forms.error.at-least-upper');
            case CLErrors.AT_LEAST_NUMBERS:
                return this.translateService.instant('forms.error.at-least-numbers');
            case CLErrors.AT_LEAST_SYMBOLS:
                return this.translateService.instant('forms.error.at-least-symbols');
            case CLErrors.FLOAT:
                return this.translateService.instant('forms.error.float');
            case 'pattern':
                return this.translateService.instant('forms.error.invalid-format');
            case 'invalidInternalName':
                return this.translateService.instant('forms.error.invalid-internal-name');
            case CLErrors.INVALID_FILE_TYPE: {
                const fileType = <{ accepted: string }>error.value;
                return this.translateService.instant('common.file-upload.invalid-type', { accepted: fileType.accepted });
            }
            case CLErrors.MAX_FILE_SIZE: {
                const value = <{ max: number }>error.value;
                return this.translateService.instant('common.file-upload.max-size', { max: value.max / 1_000_000 });
            }
            case 'nonAscii':
                return this.translateService.instant('forms.error.non-ascii');
            case 'slugTaken':
                return this.translateService.instant('forms.error.slug-taken');
            case 'passwordTooShort': {
                const value = <{ requiredLength: number }>error.value;
                return this.translateService.instant('forms.error.password-too-short', { min: value.requiredLength });
            }
            case 'passwordTooLong': {
                const value = <{ requiredLength: number }>error.value;
                return this.translateService.instant('forms.error.password-too-long', { max: value.requiredLength });
            }
            case 'passwordMustIncludeUpperCharacter':
                return this.translateService.instant('forms.error.password-must-include-upper-character');
            case 'passwordMustIncludeDigit':
                return this.translateService.instant('forms.error.password-must-include-digit');
            case 'passwordMustIncludeSpecialCharacter':
                return this.translateService.instant('forms.error.password-must-include-special-character');
            case 'passwordHasLeadingOrTrailingWhitespace':
                return this.translateService.instant('forms.error.password-has-leading-or-trailing-whitespace');
            default:
                return this.translateService.instant('forms.error.default');
        }
    }
}
